import { lazy } from 'react';

export const AsyncAboutPageContainer = lazy(() => import(
  /* webpackChunkName: 'about_page' */
  './AboutPageContainer'
));
